export default {
	title: "Please verify your email",
	para1: "For security purposes, check your inbox and verify your email address to continue logging in.",
	para2: "Didn't receive an email? <a href=\"#\" data-action=\"resend\">Re-send verification</a>.",
	para3: "Having trouble? Try <a href=\"/t2/logout\">logging out</a>, then logging back in. If the issues persist, please send a message to <a href=\"mailto:info{'@'}teaming.com\">info{'@'}teaming.com</a>.",
	confirmation: "Verification email sent.",
};
